// React Basic and Bootstrap
import React, { Component } from "react"
import { Container, Row, Col } from "reactstrap"
import { Link } from "react-router-dom"

//Import Slick Slider
import Slider from "react-slick"

//Import Slick Slider CSS
import "../../../node_modules/slick-carousel/slick/slick.css"
import "../../../node_modules/slick-carousel/slick/slick-theme.css"

// Import images
import slider01 from "../../assets/images/single/shaft-slider-new-1.png"
import slider02 from "../../assets/images/single/shaft-slider-new-2.png"
import slider03 from "../../assets/images/single/shaft-slider-new-3.png"
import slider04 from "../../assets/images/single/shaft-slider-2.png"
import slider05 from "../../assets/images/single/shaft-slider-3.png"
import slider06 from "../../assets/images/single/shaft-slider-4.png"
import slider07 from "../../assets/images/single/shaft-slider-5.png"

class Feature extends Component {
  constructor(props) {
    super(props)
    this.state = {
      features_lines: [
        { title: "Digital Marketing Solutions for Tomorrow" },
        { title: "Create your own skin to match your brand" },
      ],
    }
  }
  render() {
    const settings = {
      autoplay: true,
      infinite: true,
      autoplaySpeed: 1500,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      draggable: true,
      pauseOnHover: true,
    }

    return (
      <React.Fragment>
        <section className="section bg-light">
          <Container>
            <Row className="align-items-center">
              <Col lg={6} md={6}>
                <Slider {...settings}>
                  <div>
                    <img src={slider01} className="img-fluid rounded" alt="" />
                  </div>
                  <div>
                    <img src={slider02} className="img-fluid rounded" alt="" />
                  </div>
                  <div>
                    <img src={slider03} className="img-fluid rounded" alt="" />
                  </div>
                  <div>
                    <img src={slider04} className="img-fluid rounded" alt="" />
                  </div>
                  <div>
                    <img src={slider05} className="img-fluid rounded" alt="" />
                  </div>
                  <div>
                    <img src={slider06} className="img-fluid rounded" alt="" />
                  </div>
                  <div>
                    <img src={slider07} className="img-fluid rounded" alt="" />
                  </div>
                </Slider>
              </Col>

              <Col lg={6} md={6} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                <div className="section-title ms-lg-3">
                  <h4 className="title mb-4">Precision Boat Shafts. Built In-House. Ready to Ship.</h4>
                  <p className="text-muted">General Propeller Company is a leading U.S. boat shaft manufacturer and OEM supplier to many of the industry’s top builders. We stock shafting from 3/4" to 4" diameter and machine every shaft in-house on CNC equipment to exacting ABYC standards.</p>
                  <p className="text-muted">Each shaft is inspected for straightness, diameter, and roundness, and coupling assemblies are fully fitted and verified for runout before shipment.</p>
                  <Link
                    to="#shaft-price-estimator"
                    onClick={(e) => {
                      e.preventDefault()
                      const el = document.getElementById("shaft-price-estimator")
                      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" })
                    }}
                    className="mt-3 text-primary"
                  >
                    Request current pricing through our Inboard Shaft Quote Form. <i className="uil uil-angle-right-b"></i>
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    )
  }
}

export default Feature
